import { calEvents, isCalEventId } from '../../Core/Constants/CalEvents';
import { getContent } from "../../Core/Content/store";
import type { PhotographyPackageModel } from "../../Core/Models/PackageModels";

export const getPhotographyPackagesFn = (): PhotographyPackageModel[] => getContent("packages").items.map(item => {
  // Keep descriptive CMS content, with duration and price aligned to the configured booking event.
  const event = isCalEventId(item.id) ? calEvents[item.id] : null;
  return event ? { ...item, duration: event.duration, startingPrice: event.price, fullAmount: event.price } : item;
}) as PhotographyPackageModel[];

export const getFeaturedPackageFn = () =>
  getPhotographyPackagesFn().find((item) => item.featured) ?? getPhotographyPackagesFn()[0];

export const findPhotographyPackageByIdFn = (packageId: string) =>
  getPhotographyPackagesFn().find((item) => item.id === packageId) ?? null;
